export default __webpack_public_path__ + "static/media/python.630e0d30.gif";